<jhi-modal title="{{ 'study-editor.observation-sample-details-modal.title' | translate }}">
    <div class="modal-body">
        <div class="row pt-3">
            <div class="col">
                <div class="d-flex align-items-center">
                    <span class="me-2" jhiTranslate="global.records.per.page">Records per page:</span>
                    <select class="form-select form-select-sm" style="width: auto;"
                            (change)="onPageSizeChange($event)">
                        @for (option of pageSizeOptions; track option) {
                            <option [value]="option" [selected]="pageSize === option">{{ option }}</option>
                        }
                    </select>
                </div>
            </div>
        </div>
        <div class="row pt-1">
            <div class="col">
                @if (enntries && enntries.length > 0) {
                    <div class="table-responsive mt-3">
                        <div class="custom-scroll-style" style="max-height: 500px; overflow-y: auto; overflow-x: auto;">
                            <table id="review-design-table"
                                   class="table table-striped table-bordered table-curved">
                                <thead class="sticky-header">
                                <tr>
                                    <th jhiTranslate="study-editor.observation-sample-details-modal.column.sample.id">SAMPLE ID</th>
                                    <th jhiTranslate="study-editor.observation-sample-details-modal.column.sample.list">SAMPLE LIST</th>
                                    <th jhiTranslate="study-editor.observation-sample-details-modal.column.sample.study">SAMPLE STUDY NAME</th>
                                    <th jhiTranslate="study-editor.observation-sample-details-modal.column.taken.by">TAKEN BY</th>
                                    <th jhiTranslate="study-editor.observation-sample-details-modal.column.sampling.date">SAMPLING DATE</th>
                                    <th jhiTranslate="study-editor.observation-sample-details-modal.column.dataset.type">DATASET_TYPE</th>
                                    <th jhiTranslate="study-editor.observation-sample-details-modal.column.obsUnitId">OBS UNIT ID</th>
                                    <th jhiTranslate="study-editor.observation-sample-details-modal.column.enumerator">ENUMERATOR</th>
                                    <th jhiTranslate="study-editor.observation-sample-details-modal.column.plateId">PLATE_ID</th>
                                    <th jhiTranslate="study-editor.observation-sample-details-modal.column.well">WELL</th>
                                </tr>
                                </thead>
                                <tbody>
                                <!-- Use pagedData instead of importedData -->
                                <tr *ngFor="let row of enntries; let i = index">
                                    <td>{{row.sampleId}}</td>
                                    <td>{{row.sampleList}}</td>
                                    <td>{{row.studyName}}</td>
                                    <td>{{row.takenBy}}</td>
                                    <td>{{row.samplingDate}}</td>
                                    <td>{{row.datasetType}}</td>
                                    <td>{{row.observationUnitId}}</td>
                                    <td>{{row.enumerator}}</td>
                                    <td>{{row.plateId}}</td>
                                    <td>{{row.well}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Pagination controls -->
                        <div class="d-flex justify-content-between align-items-center mt-3">
                            <div>
								<span jhiTranslate="study-editor.pagination.entry-count"
									  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, totalItems), param3: totalItems}"></span>
                            </div>
                            <ngb-pagination
                                    [collectionSize]="totalItems"
                                    [(page)]="currentPage"
                                    [pageSize]="pageSize"
                                    [maxSize]="5"
                                    [rotate]="true"
                                    [boundaryLinks]="true"
                                    (pageChange)="onPageChange($event)">
                            </ngb-pagination>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button (click)="finish()" class="btn btn-primary">
            <span translate="ok"></span>
        </button>
    </div>
</jhi-modal>
